module.exports = __webpack_public_path__ + "a50c0d14b05dee9d2f266967b953e942.svg";